import React, { useCallback, useState } from 'react';
import Dropzone from 'react-dropzone';
import { toast } from 'react-toastify';

import { Button, Card, Flex, Typography } from 'antd';
import { Icon } from '@eduzz/ui-antd-theme';

import ModalActions from 'components/ModalActions';
import Spin from 'components/Spin';
import Truncate from 'v2/components/Shared/TruncateText';
import uploadService from 'v2/services/upload';

interface IProps {
  isModal: boolean;
  open: boolean;
  onClose: any;
  onOk: any;
}

const File = ({ isModal, open, onClose, onOk }: IProps) => {
  const [files, setFiles] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  const handleOk = useCallback(() => {
    if (files?.length) {
      if (onOk) {
        const newFile: any = {};
        newFile.method_id = '5';
        newFile.files = files;
        onOk(newFile);
        toast.success('Arquivo(s) adicionado(s) com sucesso!');
        setFiles([]);
      }
    } else {
      toast.warn('Por favor adicione pelo menos um arquivo');
    }
  }, [files, onOk]);

  const onDrop = useCallback((droppedFiles: any) => {
    (async () => {
      try {
        for (let i = 0; i < droppedFiles.length; i++) {
          setLoading(true);
          const result = await uploadService.uploadFile(droppedFiles[i], 'entregar_arquivo');
          droppedFiles[i].upload_id = result.data.upload_id;
          droppedFiles[i].new = true;
        }

        setFiles(prev => prev.concat(droppedFiles));
        setLoading(false);
      } catch (error) {
        toast.error(error);
        setLoading(false);
      }
    })();
  }, []);

  const onRemoveItem = useCallback(
    (index: number, item: any) => {
      const newFiles = [...files];
      newFiles.splice(index, 1);
      setFiles(newFiles);
      toast.success(`Arquivo ${item.name} removido com sucesso!`);
    },
    [files]
  );

  const content = (
    <div>
      {loading ? (
        <div>
          <Spin />
          <Typography.Paragraph>Por favor, aguarde. Estamos fazendo upload do(s) arquivo(s)...</Typography.Paragraph>
        </div>
      ) : (
        <div>
          <Dropzone onDrop={onDrop}>
            {({ getRootProps, getInputProps }) => (
              <section>
                <div
                  className='h-full cursor-pointer rounded-sm border-2 border-dashed border-(--uizz-antd-color-border) bg-(--uizz-antd-color-fill-alter) p-6 text-center'
                  {...getRootProps()}
                >
                  <input {...getInputProps()} id='input-product-delivery-files' />
                  <Icon.CloudUpload  />
                  <Typography.Paragraph>Selecione ou arraste um ou mais arquivos aqui.</Typography.Paragraph>
                  <Typography.Text type='secondary' italic>
                    Para PDFs, o DRM só será aplicado caso o documento não esteja bloqueado ou criptografado com senha
                  </Typography.Text>
                </div>
              </section>
            )}
          </Dropzone>

          <ul className='list-none p-0'>
            {files?.length
              ? files.map((item: any, index: number) => (
                  <li key={`file-${item.name}`} className='border-b border-(--uizz-antd-color-border) py-2'>
                    <Flex align='center' justify='space-between'>
                      <Truncate count={24} final='...'>
                        {item.name}
                      </Truncate>
                      <Button type='text' icon={<Icon.X  />} onClick={() => onRemoveItem(index, item)} />
                    </Flex>
                  </li>
                ))
              : 'Nenhum arquivo adicionado.'}
          </ul>
        </div>
      )}
    </div>
  );

  return (
    <div>
      {isModal ? (
        <ModalActions
          title='Entrega de Conteúdo'
          buttonOk='Salvar'
          open={open}
          onClose={onClose}
          onOk={handleOk}
          loading={loading}
        >
          {content}
        </ModalActions>
      ) : (
        <Card title='Entrega de Conteúdo' extra={<Button type='text' icon={<Icon.X  />} />}>
          {content}
        </Card>
      )}
    </div>
  );
};

export default File;
